module.exports = __webpack_public_path__ + "img/recycle-bin.ba0e1392.svg";